import {ResourcesLoader} from '@fantasmagames/core/src/loader/ResourcesLoader';
import {ViewTypes} from '@fantasmagames/slot/src/common/view/View';
import {ReelConstants} from '@fantasmagames/slot/src/modules/reels/ReelConstants';

export enum Symbols {
	WR = 0,
	// medium wins
	M1,
	M2,
	M3,
	M4,
	M5,
	// low wins
	F6,
	F7,
	F8,
	F9,
	F10,
	// other
	BN,
	RS,
	TOP_WR,
	TOP_BN,
	TOP_RS,
}

export class SymbolsCreation {
	public static addBackgroundsIntoSprite(
		spr: PIXI.Sprite,
		resources: ResourcesLoader,
		viewType: ViewTypes = ReelConstants.DEFAULT_VIEW,
	): void {}

	public static addAllSymbolsIntoSprite(
		spr: PIXI.Sprite,
		resources: ResourcesLoader,
		viewType: ViewTypes = ReelConstants.DEFAULT_VIEW,
	): void {
		spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', `WR.png`, viewType))); // wild x1
		spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', `M1.png`, viewType))); // medium win symbol
		spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', `M2.png`, viewType))); // medium win symbol
		spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', `M3.png`, viewType))); // medium win symbol
		spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', `M4.png`, viewType))); // medium win symbol
		spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', `M5.png`, viewType))); // medium win symbol
		spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', `F6.png`, viewType))); // low win symbol
		spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', `F7.png`, viewType))); // low win symbol
		spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', `F8.png`, viewType))); // low win symbol
		spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', `F9.png`, viewType))); // low win symbol
		spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', `F10.png`, viewType))); // low win symbol
		spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', `BN.png`, viewType))); // Scatter
		spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', `RS.png`, viewType))); // respin
		spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', `TOP_WR.png`, viewType))); // TOP wild
		spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', `TOP_BN.png`, viewType))); // TOP scatter
		spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', `TOP_RS.png`, viewType))); // TOP Respin
	}
}

export enum SymbolMultipliers {
	SYM_X_1 = 1,
	SYM_X_2,
	SYM_X_3,
	SYM_X_4,
	SYM_X_5,
}

export class SymbolPayouts {
	public static readonly paytable: any = {
		[Symbols.WR]: {
			values: {
				[SymbolMultipliers.SYM_X_1]: 0,
				[SymbolMultipliers.SYM_X_2]: 0,
				[SymbolMultipliers.SYM_X_3]: 10,
				[SymbolMultipliers.SYM_X_4]: 70,
				[SymbolMultipliers.SYM_X_5]: 200,
			},
			id: Symbols.WR,
		},
		[Symbols.M1]: {
			values: {
				[SymbolMultipliers.SYM_X_1]: 0,
				[SymbolMultipliers.SYM_X_2]: 0,
				[SymbolMultipliers.SYM_X_3]: 10,
				[SymbolMultipliers.SYM_X_4]: 70,
				[SymbolMultipliers.SYM_X_5]: 200,
			},
			id: Symbols.M1,
		},
		[Symbols.M2]: {
			values: {
				[SymbolMultipliers.SYM_X_1]: 0,
				[SymbolMultipliers.SYM_X_2]: 0,
				[SymbolMultipliers.SYM_X_3]: 10,
				[SymbolMultipliers.SYM_X_4]: 60,
				[SymbolMultipliers.SYM_X_5]: 175,
			},
			id: Symbols.M2,
		},
		[Symbols.M3]: {
			values: {
				[SymbolMultipliers.SYM_X_1]: 0,
				[SymbolMultipliers.SYM_X_2]: 0,
				[SymbolMultipliers.SYM_X_3]: 10,
				[SymbolMultipliers.SYM_X_4]: 50,
				[SymbolMultipliers.SYM_X_5]: 150,
			},
			id: Symbols.M3,
		},
		[Symbols.M4]: {
			values: {
				[SymbolMultipliers.SYM_X_1]: 0,
				[SymbolMultipliers.SYM_X_2]: 0,
				[SymbolMultipliers.SYM_X_3]: 10,
				[SymbolMultipliers.SYM_X_4]: 40,
				[SymbolMultipliers.SYM_X_5]: 125,
			},
			id: Symbols.M4,
		},
		[Symbols.M5]: {
			values: {
				[SymbolMultipliers.SYM_X_1]: 0,
				[SymbolMultipliers.SYM_X_2]: 0,
				[SymbolMultipliers.SYM_X_3]: 10,
				[SymbolMultipliers.SYM_X_4]: 30,
				[SymbolMultipliers.SYM_X_5]: 100,
			},
			id: Symbols.M5,
		},
		[Symbols.F6]: {
			values: {
				[SymbolMultipliers.SYM_X_1]: 0,
				[SymbolMultipliers.SYM_X_2]: 0,
				[SymbolMultipliers.SYM_X_3]: 5,
				[SymbolMultipliers.SYM_X_4]: 15,
				[SymbolMultipliers.SYM_X_5]: 30,
			},
			id: Symbols.F6,
		},
		[Symbols.F7]: {
			values: {
				[SymbolMultipliers.SYM_X_1]: 0,
				[SymbolMultipliers.SYM_X_2]: 0,
				[SymbolMultipliers.SYM_X_3]: 5,
				[SymbolMultipliers.SYM_X_4]: 15,
				[SymbolMultipliers.SYM_X_5]: 30,
			},
			id: Symbols.F7,
		},
		[Symbols.F8]: {
			values: {
				[SymbolMultipliers.SYM_X_1]: 0,
				[SymbolMultipliers.SYM_X_2]: 0,
				[SymbolMultipliers.SYM_X_3]: 2,
				[SymbolMultipliers.SYM_X_4]: 10,
				[SymbolMultipliers.SYM_X_5]: 20,
			},
			id: Symbols.F8,
		},
		[Symbols.F9]: {
			values: {
				[SymbolMultipliers.SYM_X_1]: 0,
				[SymbolMultipliers.SYM_X_2]: 0,
				[SymbolMultipliers.SYM_X_3]: 2,
				[SymbolMultipliers.SYM_X_4]: 10,
				[SymbolMultipliers.SYM_X_5]: 20,
			},
			id: Symbols.F9,
		},
		[Symbols.F10]: {
			values: {
				[SymbolMultipliers.SYM_X_1]: 0,
				[SymbolMultipliers.SYM_X_2]: 0,
				[SymbolMultipliers.SYM_X_3]: 2,
				[SymbolMultipliers.SYM_X_4]: 10,
				[SymbolMultipliers.SYM_X_5]: 20,
			},
			id: Symbols.F10,
		},
	};
}



// WEBPACK FOOTER //
// ./src/reels/Symbols.ts